import React from 'react';

import './Sidebar.css';

class Sidebar extends React.Component {
    constructor(props) {
        super(props);

        let visible = false;

        this.state = {
            visible: visible
        };

        let swipeCoordX, swipeCoordX2;
        let swipeMinDistance = 100;
        let self = this;

        document.addEventListener("mousedown", function(pointer){
            swipeCoordX = pointer.clientX;
        }, false);
        
        document.addEventListener("mouseup", function(pointer){
            swipeCoordX2 = pointer.clientX;  
            if (swipeCoordX2 < swipeCoordX - swipeMinDistance) {
                setTimeout(function() {
                    self.props.onChange(false);
                }, 350);
                self.setState({
                    visible: false
                });
            }
            else if (swipeCoordX2 > swipeCoordX + swipeMinDistance) {
                setTimeout(function() {
                    self.props.onChange(true);
                }, 350);
                self.setState({
                    visible: true
                });
            } 
        }, false);
    }

    render() {
        return (
            <div className={"sidebar_wrapper " + (this.state.visible ? "visible" : "")}>
                {this.props.children}
                <div className="sbButton">
                    <div className="menuToggle" onClick={this.onClick.bind(this)}>
                        <input className="menuInput" type="checkbox" checked={this.state.visible} />
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        );
    }

    onClick(args) {
        this.setState({
            visible: !this.state.visible
        });
    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/Sidebar/Sidebar.react.js